// État d'une facture ou d'un devis tel que le client le lit dans son espace.

export interface ClientBillingStatusInput {
  doc_type: string;
  status: string;
  due_date: string | null;
  remaining_amount: number | null;
}

export type ClientBillingTone = 'ok' | 'neutral' | 'late';

function frDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

/** `today` au format AAAA-MM-JJ. */
export function clientBillingStatus(
  doc: ClientBillingStatusInput,
  today: string,
): { label: string; tone: ClientBillingTone } {
  if (doc.doc_type === 'estimate') {
    if (doc.status === 'accepted') return { label: 'Accepté', tone: 'ok' };
    if (doc.status === 'rejected') return { label: 'Refusé', tone: 'neutral' };
    return { label: 'Proposé', tone: 'neutral' };
  }
  if (doc.status === 'paid' || (doc.remaining_amount !== null && Number(doc.remaining_amount) <= 0)) {
    return { label: 'Payée', tone: 'ok' };
  }
  if (doc.status === 'overdue' || (doc.due_date && doc.due_date.slice(0, 10) < today)) {
    return { label: 'En retard', tone: 'late' };
  }
  if (doc.due_date) return { label: `À régler avant le ${frDate(doc.due_date)}`, tone: 'neutral' };
  return { label: 'À régler', tone: 'neutral' };
}
